import { c as _c } from "react-compiler-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const UploadCloud01 = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.2,
      d: "M4 16.2422c-1.206-.8072-2-2.182-2-3.7422 0-2.3436 1.7915-4.2687 4.0797-4.4806C6.5478 5.172 9.0202 3 12 3s5.4522 2.1721 5.9203 5.0194C20.2085 8.2313 22 10.1564 22 12.5c0 1.5602-.794 2.935-2 3.7422M8 16l4-4m0 0 4 4m-4-4v9"
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = /*#__PURE__*/_jsx("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: t0
    });
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default UploadCloud01;
//# sourceMappingURL=UploadCloud01.js.map